import React from "react";
import "./navbar.scss";
import logo from "../../assets/logo.png";
import { navMenuItems } from "../../constants";

const handleHashNavigation = (url) => {
  window.location.replace(window.location.origin + "/" + url);
};
const Navbar = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg app-bar menu">
        <div
          className="collapse navbar-collapse flex-row"
          id="navbarTogglerDemo02"
        >
          <div className="nav-item pl-4">
            <a onClick={() => handleHashNavigation('#home')}
              href="#home">
              <img src={logo} alt="logo" />
            </a>
          </div>
          <div className="navbar-nav ml-auto mt-2 pr-4">
            <ul>
              {navMenuItems.map(({ name, url }, index) => {
                return (
                  <li key={index} className="nav-item active">
                    <a
                      className="nav-link"
                      onClick={() => handleHashNavigation(url)}
                      href={url}
                    >
                      {name}
                    </a>
                  </li>
                );
              })}

              <div className="underbar"></div>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
